import { RefObject, useEffect, useState } from 'react';

const isScrollable = (element: HTMLElement): boolean => {
  const { overflowX } = window.getComputedStyle(element);
  return overflowX === 'auto' || overflowX === 'scroll';
};

const findScrollContainer = (element: HTMLElement | null): HTMLElement | null => {
  let current = element?.parentElement ?? null;

  while (current) {
    if (isScrollable(current)) return current;
    current = current.parentElement;
  }

  return null;
};

export const useScrollContainerWidth = (ref: RefObject<HTMLElement>, enabled: boolean): number | undefined => {
  const [width, setWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!enabled) return;

    const container = findScrollContainer(ref.current);
    if (!container) return;

    setWidth(container.clientWidth);

    if (typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(() => setWidth(container.clientWidth));
    observer.observe(container);

    return () => observer.disconnect();
  }, [ref, enabled]);

  return width;
};
